var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"id":"grand-union","active":_vm.enabledGrandUnion,"title":""},on:{"update:active":function($event){_vm.enabledGrandUnion=$event},"close":function($event){_vm.enabledGrandUnion = true}}},[_c('GrandUnionFields',{attrs:{"decoded":_vm.decoded},on:{"selectPercentagem":_vm.onSubmitPercentagem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }